<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle">Table of Contents</h1><p class="left"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="left"><a href="#/toc">Table of Contents</a></p>
<p class="left"><a href="#/front01">Copyright</a></p>
<p class="left"><a href="#/c01">The Hill of Evil Counsel</a></p>
<p class="left"><span href="#/c02" title="Link target outside of Sample">Mr. Levi</span></p>
<p class="left"><span href="#/c03" title="Link target outside of Sample">Longing</span></p>
<p class="left"><span href="#/back01" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?c01edbb0